import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  IconButton,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import * as React from "react";
import { CalibrationPoint } from "../../../../types";

type Props = {
  calibrationPoints: CalibrationPoint[];
  onEdit: (point: CalibrationPoint) => void;
  onDelete: (pointId: string) => void;
  onHighlight: (pointId: string | null) => void;
};

export const CalibrationPointsList: React.FC<Props> = ({
  calibrationPoints,
  onDelete,
  onHighlight,
}) => {
  if (calibrationPoints.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" align="center">
        No calibration points added
      </Typography>
    );
  }

  return (
    <Box sx={{ maxHeight: 200, overflowY: "auto" }}>
      <List dense sx={{ py: 0 }}>
        {calibrationPoints.map((point) => (
          <ListItem
            key={point.id}
            onMouseEnter={() => onHighlight(point.id)}
            onMouseLeave={() => onHighlight(null)}
            sx={{
              borderRadius: 1,
              mb: 0.5,
              py: 1.5,
              px: 2,
              border: "1px solid",
              borderColor: "divider",
              backgroundColor: "background.paper",
              "&:hover": {
                backgroundColor: "action.hover",
                borderColor: "primary.main",
              },
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={2}
            >
              <Stack direction="column" sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  component="div"
                  variant="caption"
                  sx={{
                    fontFamily: "monospace",
                    color: "text.primary",
                    fontSize: "0.7rem",
                  }}
                >
                  {point.latitude}, {point.longitude}
                </Typography>
                <Typography
                  component="div"
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.7rem" }}
                >
                  Position: ({point.x * 100}%, {(point.y * 100).toFixed(1)}%)
                </Typography>
              </Stack>
              <Stack direction="row" spacing={0.5} sx={{ flexShrink: 0 }}>
                {/* <IconButton size="small" onClick={() => onEdit(point)}>
                  <EditIcon fontSize="small" />
                </IconButton> */}
                <IconButton
                  size="small"
                  onClick={() => onDelete(point.id)}
                  color="error"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Stack>
            </Stack>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
